import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Film,
  Users,
  Shield,
  Sparkles,
  Award
} from "lucide-react";
import Layout from "../../../components/web/Layout";
import { Helmet } from "react-helmet";

function History() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      easing: "ease-out-cubic",
      offset: 100,
    });
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>Our History | Chadak All Film Kamgar Sanghatana</title>
      </Helmet>

      <section className="bg-gradient-to-b from-sky-50 via-white to-sky-100 py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4">

          {/* ================= HEADER ================= */}
          <div className="text-center mb-14" data-aos="fade-down">
            <span className="inline-block px-5 py-2 bg-gradient-to-r from-blue-800 to-blue-600 text-white text-sm font-semibold rounded-full shadow mb-4">
              Our Legacy
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-slate-800">
              Our History & Mission
            </h1>
            <p className="text-slate-600 mt-4 max-w-3xl mx-auto text-base md:text-lg">
              Standing strong with Film & Television workers, artists, and technicians
            </p>
          </div>

          {/* ================= MAIN CONTENT ================= */}
          <div
            className="bg-white rounded-3xl shadow-lg p-6 md:p-10 lg:p-12"
            data-aos="fade-up"
          >
            <p className="text-slate-700 text-base md:text-lg leading-relaxed mb-6">
              All the workers and artists associated with Film & TV production houses
              are requested to take note. We are here to resolve the challenges faced
              by professionals working in the Film and Television industry.
            </p>

            <p className="text-slate-700 text-base md:text-lg leading-relaxed mb-6">
              Our organization actively supports <strong>Film & TV Actors, Actresses,
              Directors, Junior Artists, Duplicates, Camera Men, Dress Men, Hair Dressers,
              Carpenters, Light Men, Production Staff, Spot Boys</strong>, and all other
              film and television technicians.
            </p>

            <p className="text-slate-700 text-base md:text-lg leading-relaxed mb-8">
              Our active film unit is always available to understand your problems and
              ensure they are resolved at the earliest with fairness, dignity, and justice.
            </p>

            {/* ================= FEATURES ================= */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10">
              {[
                { icon: <Users />, label: "Worker Support" },
                { icon: <Film />, label: "Film & TV Industry" },
                { icon: <Shield />, label: "Rights Protection" },
                { icon: <Sparkles />, label: "Fair Treatment" },
              ].map((item, index) => (
                <div
                  key={index}
                  data-aos="zoom-in"
                  data-aos-delay={index * 100}
                  className="flex flex-col items-center text-center bg-sky-50 rounded-xl p-5 shadow-sm hover:shadow-md transition"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-gradient-to-br from-blue-800 to-blue-600 text-white mb-3">
                    {item.icon}
                  </div>
                  <p className="font-semibold text-slate-800 text-sm md:text-base">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* ================= LEADER SECTION ================= */}
          <div
            className="mt-16 bg-gradient-to-r from-blue-900 to-blue-700 text-white rounded-3xl p-8 md:p-12 shadow-xl"
            data-aos="fade-up"
          >
            <div className="text-center">
              <Award className="w-12 h-12 mx-auto mb-4 text-yellow-400" />
              <h2 className="text-2xl md:text-4xl font-bold mb-2">
                Prominent Labour Leader
              </h2>
              <p className="text-xl md:text-2xl font-semibold mt-4">
                Mr. Abhijeet Rane
              </p>
              <p className="text-sm md:text-base text-sky-200 mt-1">
                General Secretary
              </p>
              <p className="text-sm md:text-base text-sky-200 mt-1">
                Chadak All Film Kamgar Sanghatana
              </p>
            </div>
          </div>

        </div>
      </section>
    </Layout>
  );
}

export default History;
